/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Weibelfeldschule1Inputs */

const en__field_enum_weibelfeldschule1 = /** @type {(inputs: _Field_Enum_Weibelfeldschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreieich`)
};

const de__field_enum_weibelfeldschule1 = /** @type {(inputs: _Field_Enum_Weibelfeldschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weibelfeldschule`)
};

/**
* | output |
* | --- |
* | "Dreieich" |
*
* @param {_Field_Enum_Weibelfeldschule1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_weibelfeldschule1 = /** @type {((inputs?: _Field_Enum_Weibelfeldschule1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Weibelfeldschule1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_weibelfeldschule1(inputs)
	return de__field_enum_weibelfeldschule1(inputs)
});
export { _field_enum_weibelfeldschule1 as "_field_enum_Weibelfeldschule" }